import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { ClockProvider, realClock } from '@/lib/clock';
import { createRouter } from '@/routes/routes';

export default function App() {
  const [router] = useState(createRouter);

  return (
    <ClockProvider clock={realClock}>
      <RouterProvider router={router} />
      <Toaster />
    </ClockProvider>
  );
}
